"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cyanobacteria = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var ResourceType_1 = require("../../ResourceType");
var AddResourcesToCards_1 = require("../../deferredActions/AddResourcesToCards");
var Cyanobacteria = (function (_super) {
    __extends(Cyanobacteria, _super);
    function Cyanobacteria() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.CYANOBACTERIA,
            cost: 12,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.MARS],
            tr: { oxygen: 1 },
            metadata: {
                cardNumber: 'Pf27',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.oxygen(1).br;
                    b.microbes(1).asterix().slash().oceans(1).br;
                }),
                description: 'Raise the oxygen level 1%. For every ocean tile, place a microbe on any card.',
            },
        }) || this;
    }
    Cyanobacteria.prototype.play = function (player) {
        player.game.increaseOxygenLevel(player, 1);
        var microbes = player.game.board.getOceansOnBoard();
        player.game.defer(new AddResourcesToCards_1.AddResourcesToCards(player, ResourceType_1.ResourceType.MICROBE, microbes));
        return undefined;
    };
    return Cyanobacteria;
}(Card_1.Card));
exports.Cyanobacteria = Cyanobacteria;
